import { createSlice } from '@reduxjs/toolkit';
import DeviceApiService from '../provider/redux/query/device.service';
const initialState = {
  devices: [],
  totalRecords: 0,
  page: 1,
};

const deviceSlice = createSlice({
  name: 'devices',
  initialState,
  extraReducers: builder => {
    builder
      .addMatcher(DeviceApiService.endpoints.getDevices.matchFulfilled, (state, action) => {
        // console.log('================================');
        // console.log('getDevices [matchFulfilled] =>', action.payload);
        // console.log('================================');
        const { devices } = action.payload.data;
        state.devices = devices;
        state.totalRecords = devices.length;
        state.loading = false;
      })
      .addMatcher(DeviceApiService.endpoints.getDevices.matchPending, state => {
        state.loading = true;
      })
      .addMatcher(DeviceApiService.endpoints.getDevices.matchRejected, state => {
        state.loading = false;
      });
  },
});

export default deviceSlice;
